export function normalizeReportCode(value?: string | null): string {
  if (!value) return '—';
  const trimmed = value.trim();
  if (!trimmed) return '—';
  // Remove "Report " prefix
  let normalized = trimmed.replace(/^Report\s+/i, '').trim();
  // Remove trailing date suffix (e.g., " 2026-01-02" or " 2026-05-02")
  normalized = normalized.replace(/\s+\d{4}-\d{2}-\d{2}$/, '').trim();
  return normalized || '—';
}
